import styled from '@emotion/styled'
import Modal from '../common/Modal'
import { Button, Flex, LabelForm, Title } from '@collable/ui'
import { useState } from 'react'
import { useChangePassword } from '@/api/auth'

const INIT_PASSWORD = {
  prevPassword: '',
  newPassword: '',
  confirmPassword: '',
}

interface ChangePasswordModalProps {
  onClose: () => void
}

const ChangePasswordModal = ({ onClose }: ChangePasswordModalProps) => {
  const { mutate: changePassword } = useChangePassword()
  const [password, setPassword] = useState(INIT_PASSWORD)

  const onChangePassword = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword({ ...password, [e.target.name]: e.target.value })
  }

  const disabled =
    !password.prevPassword ||
    password.prevPassword.length < 8 ||
    !password.newPassword ||
    password.newPassword.length < 8 ||
    password.newPassword !== password.confirmPassword

  const onSubmit = () => {
    if (disabled) return
    changePassword(
      {
        prevPassword: password.prevPassword,
        newPassword: password.newPassword,
      },
      {
        onSuccess: () => {
          onClose()
        },
        onError: () => {
          setPassword(INIT_PASSWORD)
        },
      },
    )
  }

  return (
    <Modal onClose={onClose}>
      <Container direction="column" gap={32} as="form" onSubmit={e => e.preventDefault()}>
        <Title size="title2" color="labelStrong" fontWeight="bold" as="h2">
          비밀번호 변경
        </Title>
        <Flex direction="column" gap={16}>
          <LabelForm
            label="기존 비밀번호"
            size="medium"
            value={password.prevPassword}
            onChange={onChangePassword}
            name="prevPassword"
            placeholder="기존 비밀번호 입력"
            required
            width="100%"
            type="password"
          />
          <LabelForm
            label="신규 비밀번호"
            size="medium"
            value={password.newPassword}
            onChange={onChangePassword}
            placeholder="신규 비밀번호 입력"
            name="newPassword"
            required
            width="100%"
            type="password"
          />
          <LabelForm
            label="신규 비밀번호(확인)"
            size="medium"
            value={password.confirmPassword}
            onChange={onChangePassword}
            placeholder="신규 비밀번호 입력"
            name="confirmPassword"
            required
            width="100%"
            type="password"
          />
        </Flex>
        <Flex gap={8}>
          <Button kind="soft" color="neutral" size="large" onClick={onClose} width="100%">
            취소
          </Button>
          <Button
            type="submit"
            kind="solid"
            color="primary"
            size="large"
            width="100%"
            disabled={disabled}
            onClick={onSubmit}
          >
            변경하기
          </Button>
        </Flex>
      </Container>
    </Modal>
  )
}

export default ChangePasswordModal

const Container = styled(Flex)`
  padding: 28px;
  width: 440px;
  border-radius: 20px;
  background-color: ${({ theme }) => theme.common.commonWhite};
`
